<template>
    <div class="jobCancel">
        <div class="row column-s wrap">
            <div class="grid-6-s grid-3 grid-12-s">
                Cliente
                <br />
                <strong>{{ modal.job.nome_cliente }}</strong>
            </div>
            <div v-if="modal.job.forma_atendimento" class="grid-6-s grid-5 grid-12-s">
                Atendimento
                <br />
                <strong>{{ modal.job.forma_atendimento }}</strong>
            </div>
            <div v-if="modal.job.nome_doutor" class="grid-6-s grid-4 grid-12-s">
                Supporter
                <br />
                <strong>{{ modal.job.nome_doutor }}</strong>
            </div>
            <div class="grid-12">
                Problema
                <br />
                <strong v-html="modal.job.problema.replace(/\n/g, '<br />')"></strong>
            </div>
        </div>
        <div class="column grid-12-s">
            <span>

                ATENÇÃO!!!! Cancelamento de job é uma operação irreversível!!! Esta operação cancelará TODOS os atendimentos
                feitos no job. Nenhum pagamento será feito a qualquer supporter que trabalhou no job. Nenhum recebimento
                será feito do cliente do job. Cancelar um job não é a mesma coisa do cliente ter desistido do job mas que
                ainda tem obrigação de pagar por ele. Se é este o caso encerre o job normalmente para que os pagamentos e
                cobranças sejam gerados.
            </span>
            <div class="grid-12-s">
                <div class="label">Causa do cancelamento</div>
                <select class="input" v-model="form.id_flag_cancelamento">
                    <option value="">Selecione</option>
                    <option v-for="flag of flags" :key="flag.id" :value="flag.id"> {{ flag.flag }}</option>
                </select>
            </div>
            <div class="grid-11-s">
                <div class="label">Motivo do cancelamento</div>
                <input placeholder="Motivo do cancelamento" type="text" class="input"
                    v-model="form.motivo_cancelamento" />
            </div>
        </div>
        <div class="controls row justify-center">
            <br /><br />
            <Button type="button" :loader="loader" layout="green-go" icon="fa fa-trash" @click="cancel">CANCELAR
                JOB</Button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
export default {
    name: "JobCancel",
    components: { Button },
    props: { modal: Object },
    data() {
        return {
            loader: false,
            form: { id: this.modal.job.id, id_flag_cancelamento: "", motivo_cancelamento: "" },
            flags: [],
        };
    },
    beforeMount() {
        this.FLAGS_LIST({ status: "ativo", filtro: "cancelamento" }).then(({ data }) => (this.flags = data));
    },
    computed: {
        ...mapGetters("user", ["user"]),
    },
    methods: {
        ...mapActions("admin", ["FLAGS_LIST", "JOB_CANCEL"]),
        async cancel() {
            if (confirm("Deseja cancelar este Job?")) {
                this.loader = true
                await this.JOB_CANCEL(this.form)
                this.loader = false
                this.modal.show = false
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.jobCancel
    padding: 30px
    @include label
    max-width: 600px    
    .input
        margin-top: 8px
        margin-bottom: 22px
    strong
        font-size: 16px
        color: $gray-1
    span
        color: orange
    .grid-12-s, .grid-12
        margin-top: 20px
</style>
